<template>
  <div class="central_content">
    <div style="display: flex; flex-wrap: wrap; margin-top: 10px">
      <Button
        @click="
            upData = {state:1};
            title = '添加';
            Show = true;
          "
        style="margin-right: 15px"
        type="primary"
      >添加</Button>
   
    </div>
    <Table border class="table_style" :columns="columns" :data="userList" :highlight-row="true">
  

      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '修改';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
        >修改</Button>
        <Button
          @click="
            upData = row;
            title = '删除';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
        >删除</Button>
      </template>
    </Table>
    <Modal width="1200" v-model="Show" :title="title" @on-ok="UaorderShip">
      <div v-if="title == '添加'||title == '修改'">
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>组名：</div>
          <div>
            <Input v-model="upData.name" placeholder="组名" />
          </div>
        </div>
      </div>
      <div v-if="title == '删除'">删除</div>
    
    </Modal>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      tCountStatistics: {},
      userList: [],
      userList1: { list: [] },
      title: "",
      upData: {},
      settleStatus: "",
      url: "",
      Show: false,

      parameter1: {
        pageNow: 1
      },
      columns: [
        {
          title: "id",
          className: "fontcolor",
          align: "center",
          key: "id"
        },
        {
          title: "组名",
          className: "fontcolor",
          align: "center",
          key: "name"
        },

        {
          title: "创建时间",
          className: "fontcolor",
          align: "center",
          key: "createTime"
        },
        {
          title: "修改时间",
          className: "fontcolor",
          align: "center",
          key: "modifyTime"
        },

        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          fixed: "right"
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    UaorderShip() {

      if (this.title == "添加") {
        api.ProductUrlGroupAdd(this.upData).then(res => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
      }
      if (this.title == "修改") {
        api.ProductUrlGroupEdit(this.upData).then(res => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
      }
      if (this.title == "删除") {
        api.productUrlGroupDel(this.upData.id).then(res => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
      }
    },
    getData() {
      api.ProductUrlGroupList().then(res => {
        this.userList = res.body.data;
      });
    }
  }
};
</script>

<style scoped>
</style>